export default __webpack_public_path__ + "static/media/640_dummy2016-schneiderei01-mobile-de.1bcbfda7.png";